import type { Coordinate } from './models';

const EARTH_RADIUS_METERS = 6_371_008.8;

const toRadians = (degrees: number) => (degrees * Math.PI) / 180;

export function haversineDistanceMeters(a: Coordinate, b: Coordinate): number {
  const dLat = toRadians(b.lat - a.lat);
  const dLng = toRadians(b.lng - a.lng);
  const lat1 = toRadians(a.lat);
  const lat2 = toRadians(b.lat);

  const sinLat = Math.sin(dLat / 2);
  const sinLng = Math.sin(dLng / 2);
  const h = sinLat * sinLat + Math.cos(lat1) * Math.cos(lat2) * sinLng * sinLng;
  return 2 * EARTH_RADIUS_METERS * Math.asin(Math.min(1, Math.sqrt(h)));
}

export function pathDistanceMeters(path: Coordinate[]): number {
  let total = 0;
  for (let index = 1; index < path.length; index += 1) {
    total += haversineDistanceMeters(path[index - 1], path[index]);
  }
  return total;
}

export function metersToKm(value: number): number {
  return value / 1000;
}

export function formatKm(value: number): string {
  return metersToKm(value).toLocaleString('ja-JP', {
    maximumFractionDigits: value >= 100_000 ? 0 : 1,
  });
}
